import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'product_mng',
  components: {
    planTable: function planTable() {
      return import('./plan_page');
    },
    planEnvmtTable: function planEnvmtTable() {
      return import('./plan_envmt_page');
    }
  },
  data: function data() {
    return {
      tableShow: 'plan',
      current: {}
    };
  },
  methods: {
    goPlan: function goPlan() {
      this.tableShow = 'plan';
    },
    goChild: function goChild(data, tableName) {
      this.current = data;
      this.tableShow = tableName;
    }
  }
};